import Provider from "./Provider-Api";
import CheckApi from "./check-api";

// POS MANAGEMENT

export const posGetInventoryAction = async (data, token) => {
    CheckApi('getInventory', data, token)
    const dataRes = await Provider({
        type: "POST",
        url: "/inventory/getPosProducts",
        data,
        token
    });
    CheckApi('dataRes-getInventory', dataRes)
    return dataRes;
};

export const addPosPay = async (data, token) =>{
    CheckApi('addPosPay', data, token)
    const dataRes = await Provider({
        type: "POST",
        url: "/inventory/addPosPay",
        data,
        token
    })
    CheckApi('dataRes-addPosPay', dataRes)
    return dataRes;
}

export const getOrderHistoryPos = async (data, token) => {
    CheckApi('getOrderHistoryPos', data, token)
    const dataRes = await Provider({
        type: "POST",
        url: "/inventory/getOrderHistoryPos",
        data,
        token
    })
    CheckApi('dataRes-getOrderHistoryPos', dataRes)
    return dataRes;
}

export const getPosBillDetail = async (data, token) => {
    CheckApi('getPosBillDetail', data, token)
    const dataRes = await Provider({
        type: "POST",
        url: "/inventory/getPosBillDetail",
        data,
        token
    })
    CheckApi('dataRes-getPosBillDetail', dataRes)
    return dataRes;
}

export const getNextPosNo = async (data, token) => {
    CheckApi('getNextPosNo', data, token)
    const dataRes = await Provider({
        type: "POST",
        url: "/inventory/getNextPosNo",
        data,
        token
    })
    CheckApi('dataRes-getNextPosNo', dataRes)
    return dataRes;
}

export const getNextPaymentPosId = async (data, token) => {
    CheckApi('getNextPaymentPosId', data, token)
    const dataRes = await Provider({
        type: "POST",
        url: "/inventory/getNextPaymentPosId",
        data,
        token
    })
    CheckApi('dataRes-getNextPaymentPosId', dataRes)
    return dataRes;
}




